module.exports = __webpack_public_path__ + "static/kraft-small-708aa7bec540018338ea575c59d15bc0.png";